import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJImageEnhancerInput from './FJImageEnhancerInput';
import FJUtil from '../../../util/FJUtil';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';

const FJImageEnhancerInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const uploadImages = files => {
        dispatch(FJActionImageEnhancer.uploadImagesAction(files));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction({ canMultipleChoose: true }));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    return (
        <FJImageEnhancerInput
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            uploadImages={uploadImages}
            setIsDraggingFile={_setIsDraggingFile}
            isDisabled={isDisabled}
        />
    );
};
export default FJImageEnhancerInputContainer;
